import { LoginAction } from "@/component/login/actions";
import CountDownBtn from '@/component/login/login_hlb/components/count-down-btn';
import NumberInput from '@/component/login/login_hlb/components/number-input';
import { sendSMSCode } from '@/tools/hlb';
import { setLoginUrlCache, setPlatformTokenInfo } from '@/tools/utils';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Input, message, notification } from 'antd';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getMerchantList, getMerchantToken, removeLoginData, setLoginData } from '../../utils';
import { checkExistPhone, validatePhone, validatePhoneRequired } from '../../validator';
import './login-phone.less';

const layout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 }
};
const tailLayout = {
    wrapperCol: { offset: 0, span: 24 }
};


const LoginPhone = (props) => {
    const { form } = props;

    const history = useHistory();
    const [isSend, setSend] = useState(false);
    const [disableSendBtn, setDisableSendBtn] = useState(true);
    const [btnLoading, setBtnLoading] = useState(false);
    const [isAgree, setIsAgree] = useState(false);

    const loginSuccess = (data) => {
        const _token = data.token_type + data.access_token;
        let { access_token, token_type, refresh_token, expires_in } = data;
        const _tokenInfo = {
            access_token,
            token_type,
            refresh_token,
            expires_in,
            loginWay: 'newLogin',
            nowTime: Date.parse(new Date()) / 1000
        };
        setPlatformTokenInfo(JSON.stringify(_tokenInfo));
        setLoginUrlCache();//缓存登陆url
        removeLoginData();
        props.setToken(_token);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        form.validateFields(async (err, values) => {
            if (!err) {
                try {
                    if(!isAgree) {
                        notification.warning({
                            message: '请阅读并同意协议',
                        });
                        return;
                    }
                    setBtnLoading(true);
                    const params = {
                        phone: values.phone,
                        captcha: values.captcha
                    };
                    const res = await getMerchantList(params, 'captcha')
                    window.localStorage.setItem('loginType', 'captcha');
                    if (res.status === 200) {
                        const data = res.data;
                        setLoginData({
                            params: {...params},
                            loginType: 'captcha',
                            merchants: {
                                list: data.rows,
                                total: data.total
                            },
                            needUnifiedPwd: data.needUnifiedPwd
                        });
                        // 判断是否需要设置统一密码
                        if (data && data.needUnifiedPwd) {
                            history.push('/login/unify');
                            return;
                        }
                        // 判断是否存在多个关联商户，需要选择所登录的商户
                        if (data.total > 1) {
                            history.push('/login/select');
                            return;
                        } else {
                            const getTokenParams = {
                                ...params,
                                orgId: data.rows[0].orgId
                            }
                            localStorage.setItem('orgId', data.rows[0].orgId);
                            const tokenRes = await getMerchantToken(getTokenParams, 'captcha');
                            loginSuccess(tokenRes.data);
                            history.replace('/homePage');
                        }
                    }
                } finally {
                    setBtnLoading(false);
                };
            }
        });
    };

    const handleSendSMSCode = () => {
        return new Promise((resolve, reject) => {
            const phone = form.getFieldValue('phone');
            sendSMSCode(phone)
            .then(res => {
                if (res.status === 200) {
                    setSend(true);
                    setDisableSendBtn(true);
                    message.success('验证码已发送');
                    resolve();
                } else {
                    reject('发送失败');
                }
            });
        });
    };

    return (
        <div className="login-phone">
            <Form
                {...layout}
                onSubmit={handleSubmit}
            >
                <Form.Item>
                    {
                        form.getFieldDecorator('phone', {
                            validateFirst: true,
                            validateTrigger: !form.getFieldError('phone') ? 'onBlur' : 'onChange',
                            rules: [
                                validatePhoneRequired(),
                                validatePhone(),
                                {
                                    validator: checkExistPhone
                                }
                            ]
                        })(
                            <NumberInput
                                size="large"
                                maxLength={11}
                                placeholder="请输入手机号"
                                allowClear
                                onChange={(val) => {
                                    setDisableSendBtn(String(val).length !== 11);
                                }}
                            />
                        )
                    }
                </Form.Item>

                <Form.Item
                    extra={isSend ? '验证码已发送，2分钟内输入有效' : undefined}
                >
                    <div className='phone-input'>
                        {
                            form.getFieldDecorator('captcha', {
                                validateFirst: true,
                                validateTrigger: 'onBlur',
                                rules: [
                                    { required: true, message: '请输入短信验证码' }
                                ]
                            })(
                                <Input size="large" maxLength={6} placeholder="请输入短信验证码" />
                            )
                        }
                        <CountDownBtn
                            disabled={disableSendBtn}
                            onCountStart={handleSendSMSCode}
                            onCountEnd={() => {
                                setDisableSendBtn(false);
                            }}
                        />
                    </div>
                </Form.Item>

                <div className="checkAgree">
                    <img
                        className="select-icon"
                        src={
                            isAgree ?
                                require('../../../img/selected.png') :
                                require('../../../img/unselect.png')
                        }
                        onClick={() => setIsAgree(!isAgree)}
                    />
                    {/*<Checkbox.Group>*/}
                    {/*    <Checkbox value={1} />*/}
                    {/*</Checkbox.Group>*/}
                    同意<a href="https://cdn.zhongbaounion.com/share/register/user-agreement.html" target="_blank" onClick={() => {
                    // Utils.customTrack('MerchantLoginClick', {
                    //     element_content: '用户协议'
                    // });
                }} rel="noreferrer">《用户协议》</a>和<a href="https://cdn.zhongbaounion.com/share/register/privacy-policy.html" target="_blank" onClick={() => {
                    // Utils.customTrack('MerchantLoginClick', {
                    //     element_content: '隐私协议'
                    // });
                }} rel="noreferrer">《隐私政策》</a>
                </div>

                <Form.Item {...tailLayout}>
                    <Button
                        loading={btnLoading}
                        type="primary"
                        size="large"
                        block
                        htmlType="submit"
                        className='submit-btn'
                    >
                        登录
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

const WrappedForm = Form.create()(LoginPhone);
export default connect(null, { ...LoginAction })(WrappedForm)
